import React from 'react';
import { isNative } from '../utils/capacitor';
import { APP_STORE_URL, playStoreUrl, deviceStore } from '../utils/appLinks';
import { trackAppStoreClick } from '../utils/analytics';

// Official "Download on the App Store" / "Get it on Google Play" badges, served
// from /public/badges unmodified, as both stores' brand guidelines require.
//
// Web only. Inside the apps the person already has the app, and Apple rejects
// iOS apps that point to Google Play.
//
// Google's PNG carries transparent clear-space of 41px around a 564×168 badge
// (in a 646×250 image), so it is scaled up and pulled in by that margin to make
// both badges the same visible height.
const GOOGLE = { imgH: 250 / 168, imgW: 646 / 168, inset: 41 / 168 };
const APPLE_W = 119.66407 / 40;

const AppStoreBadges = ({ placement = 'website', height = 44, className = '', style, justify = 'start' }) => {
  if (isNative()) return null;

  const apple = (
    <a key="ios" href={APP_STORE_URL} target="_blank" rel="noopener noreferrer"
      onClick={() => trackAppStoreClick('app_store', placement)}
      style={{ display: 'inline-flex', lineHeight: 0 }}>
      <img src={`${process.env.PUBLIC_URL}/badges/app-store.svg`} alt="Download on the App Store"
        width={Math.round(height * APPLE_W)} height={height} loading="lazy" />
    </a>
  );
  const google = (
    <a key="android" href={playStoreUrl(placement)} target="_blank" rel="noopener noreferrer"
      onClick={() => trackAppStoreClick('google_play', placement)}
      style={{ display: 'inline-flex', lineHeight: 0, margin: -height * GOOGLE.inset }}>
      <img src={`${process.env.PUBLIC_URL}/badges/google-play.png`} alt="Get it on Google Play"
        width={Math.round(height * GOOGLE.imgW)} height={Math.round(height * GOOGLE.imgH)} loading="lazy" />
    </a>
  );

  // The visitor's own store first; both are always shown.
  const badges = deviceStore() === 'android' ? [google, apple] : [apple, google];

  return (
    <div className={`d-flex flex-wrap align-items-center justify-content-${justify} ${className}`}
      style={{ gap: Math.round(height * 0.3), ...style }}>
      {badges}
    </div>
  );
};

export default AppStoreBadges;
